import { render } from "./EnrolledStudents.vue?vue&type=template&id=95cc4a8e"
import script from "./EnrolledStudents.vue?vue&type=script&lang=js"
export * from "./EnrolledStudents.vue?vue&type=script&lang=js"

import "./EnrolledStudents.vue?vue&type=style&index=0&id=95cc4a8e&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__